import fecha from 'fecha'

export function strPadLeft (string, pad, length) {
  return (new Array(length + 1).join(pad) + string).slice(-length)
}

export function getVideoTimeFromSeconds (time, showMS = false) {
  let minutes = Math.floor(time / 60)
  let seconds = time - minutes * 60
  if (!showMS) {
    return strPadLeft(minutes, '0', 2) + ':' + strPadLeft(seconds, '0', 2)
  } else {
    return strPadLeft(minutes, '0', 2) + ':' + strPadLeft(seconds, '0', 2)
  }
}

export function getFormattedVideoDate (timestamp) {
  let date = timestamp.slice(0, 10)
  return fecha.format(fecha.parse(date, 'YYYY-MM-DD'), 'DD.MM.YYYY')
}

export function unSlugify (slug) {
  slug = slug.replace(new RegExp('-', 'g'), ' ')
  slug = slug.charAt(0).toUpperCase() + slug.slice(1)

  return slug
}



// WEBPACK FOOTER //
// ./src/utils.js